module.exports = __webpack_public_path__ + "static/img/daping_bg.78a0d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/daping_bg.png
// module id = qih2
// module chunks = 0